import { connect } from 'react-redux';
import { Icon, IconName, Stack } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { Reservation, ServiceOrderState } from '@mews-commander/data-access';
import { getResourceCategoryIdByResourceId } from '@mews-commander/legacy-entities/src/ducks/resourceCategoryAssignments';
import { ResourceStateTag } from '../../../../components/commander-ui';
import SkipCleaningDoorHanger from '../SkipCleaningDoorHanger';
import { UnassignedResourceTag } from '../UnassignedResourceTag';
import { ResourceName } from '../../../../components/reservation/ResourceName';

interface OwnProps {
    assignedResourceId: Reservation['assignedResourceId'];
    requestedCategoryId: Reservation['requestedCategoryId'];
    serviceId: Reservation['serviceId'];
    reservationId: Reservation['id'];
    serviceOrderState: Reservation['serviceOrderState'];
}
interface StateProps {
    assignedCategoryId: string | undefined;
}
type Props = OwnProps & StateProps;

export const AssignedResource = ({
    assignedResourceId,
    requestedCategoryId,
    assignedCategoryId,
    reservationId,
    serviceOrderState,
}: Props) => (
    <Stack itemAlignment="center" spacing="100" inline>
        {assignedResourceId === null && serviceOrderState !== ServiceOrderState.Canceled ? (
            <UnassignedResourceTag />
        ) : null}
        {assignedResourceId ? (
            <>
                <ResourceName resourceId={assignedResourceId} />
                <ResourceStateTag resourceId={assignedResourceId} />
            </>
        ) : null}
        {assignedCategoryId && assignedCategoryId !== requestedCategoryId ? <Icon value={IconName.Upgraded} /> : null}
        <SkipCleaningDoorHanger reservationId={reservationId} />
    </Stack>
);

export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { assignedResourceId, serviceId }) => ({
    assignedCategoryId: assignedResourceId
        ? getResourceCategoryIdByResourceId(state, { resourceId: assignedResourceId, serviceId })
        : undefined,
}))(AssignedResource);
